import { render } from "./CardUpcomingShiftInlineSkeleton.vue?vue&type=template&id=f4caa04c&scoped=true&ts=true"
import script from "./CardUpcomingShiftInlineSkeleton.vue?vue&type=script&lang=ts"
export * from "./CardUpcomingShiftInlineSkeleton.vue?vue&type=script&lang=ts"

import "./CardUpcomingShiftInlineSkeleton.vue?vue&type=style&index=0&id=f4caa04c&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4caa04c"]])

export default __exports__